import React, { useContext } from 'react'
import './Footer.scss'
import Link from './elements/link'
import GlobalContext from '../global'
import { RichText } from 'prismic-reactjs'

const cookieLabelOptions = {
  de: 'Cookie Einstellungen',
  en: 'Cookie settings',
  it: 'Impostazioni cookie',
  fr: 'Paramètres de cookies',
  es: 'Ajustes de cookie'
}

export default function Footer() {
  const global = useContext(GlobalContext)
  let cookieLabel = cookieLabelOptions.en
  if (cookieLabelOptions[global.lang.substring(0, 2)]) {
    cookieLabel = cookieLabelOptions[global.lang.substring(0, 2)]
  }
  return (
    <div className="footer">
      <div className="footer-navi">
        <div className="footer-navi-col">
          {global.data.footer_links.length > 0 &&
            global.data.footer_links.map((link, i) => {
              return (
                <Link
                  key={`footer-link-${i}`}
                  type={link.footer_link_url.link_type}
                  target={link.footer_link_url.target}
                  url={link.footer_link_url.url}
                >
                  <a>{RichText.asText(link.footer_link_text)}</a>
                </Link>
              )
            })}
          <a onClick={() => CookieControl.open()} style={{ cursor: 'pointer' }}>
            {cookieLabel}
          </a>
        </div>
      </div>
      <div className="footer-right">
        {global.data.other_links.length > 0 && global.data.other_links[0].url.url && (
          <div className="footer-other">
            {global.data.other_links.map((link, i) => {
              return (
                <a key={`footer-link-${i}`} href={link.url.url} target={link.url.target}>
                  <img src={link.icon.url} />
                </a>
              )
            })}
          </div>
        )}
        {global.data.social_links.length > 0 && global.data.social_links[0].url.url && (
          <div className="footer-social">
            {global.data.social_links.map((link, i) => {
              return (
                <a key={`footer-link-${i}`} href={link.url.url} target={link.url.target}>
                  <img src={`/static/icons/${link.type}.svg`} alt={link.type} />
                </a>
              )
            })}
          </div>
        )}
      </div>
    </div>
  )
}
